import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarm = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-alarm",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 10l0 3l2 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 4l-2.75 2" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 4l2.75 2" })
	]
});
const ForwardRef = forwardRef(SvgAlarm);
export default ForwardRef;
